const COLORS = {
    red: "#d1462f",
    green: "#8db37b",
    gold: "#c8963e",
    darkBrown: "#423629",
    lightGray: "#ccc2c0",
    blue: "#5b8fcf",
};

const colorScheme = [
    COLORS.green,
    COLORS.gold,
    COLORS.darkBrown,
    COLORS.red,
    COLORS.blue,
];

const defaultChartOptions = {
    scales: {
        y: {
            beginAtZero: true,
        },
        x: {
            stepSize: 1,
        },
    },
    responsive: true,
    maintainAspectRatio: false,
};

function cycleColor(i) {
    return colorScheme[i % colorScheme.length];
}

function getSimplePieChart(name, labels, data, colors) {
    return getChart(
        "pie",
        labels,
        [
            {
                label: name,
                data,
            },
        ],
        undefined,
        colors
    );
}

function getSimpleBarChart(name, labels, data) {
    return getBarChart(labels, [
        {
            label: name,
            data,
        },
    ]);
}

function getBarChart(labels, datasets, options) {
    return getChart("bar", labels, datasets, options);
}

function getChart(type, labels, datasets, options, colors) {
    if (options) {
        // TODO: not the right place
        options.responsive = true;
        options.maintainAspectRatio = false;
    }

    return {
        type: type,
        data: {
            labels,
            datasets: datasets.map((dataset, i) => {
                if (
                    dataset.data.length &&
                    typeof dataset.data[0] !== "object"
                ) {
                    dataset.backgroundColor = colors ?? colorScheme;
                    return dataset;
                }
                dataset.backgroundColor =
                    dataset.backgroundColor ?? cycleColor(i);
                dataset.borderColor = cycleColor(i);
                return dataset;
            }),
        },
        options: options ?? defaultChartOptions,
    };
}

export { getSimplePieChart, getSimpleBarChart, getBarChart, getChart, COLORS };
